// Fixed 4px spacer cells that separate raid groups in the boss matrix. The body
// (BossSetupMatrix) and its footer (BossRulesFooter) share these so their column
// widths stay in lockstep.

export function RaidGap() {
  return <td aria-hidden className="w-4 min-w-4 bg-background p-0" />;
}

export function RaidHeaderGap() {
  return (
    <th aria-hidden rowSpan={2} className="w-4 min-w-4 bg-background p-0" />
  );
}
